import { type JSX, Show } from "solid-js";

import Icon from "@/components/Icon.tsx";
import { useI18n } from "@/i18n";
import { isMobile } from "@/lib/isMobile.ts";
import { cn } from "@/lib/tailwindcssTool";

interface CardHeaderProps {
  title: string | JSX.Element;
  closeCallback?: () => void;
  showClose?: boolean;
  class?: string;
  style?: JSX.CSSProperties | string;
  icon?: string;
  tip?: string;
  tipCallback?: () => void;
}

export default function CardHeader(props: CardHeaderProps) {
  const { t } = useI18n();
  const icon = () => (props.icon !== undefined ? props.icon : "");
  return (
    <div
      class={cn(
        "inline-flex w-full justify-between",
        isMobile() ? "px-[12px]" : "px-[14px]",
        props.class,
      )}
      style={props?.style}
    >
      <h3 class="flex-center inline-flex text-center font-semibold">
        {props.title}
      </h3>
      <Show
        when={props?.closeCallback && icon() === "xx1" && props.showClose}
        fallback={<></>}
      >
        {/*<div*/}
        {/*  onClick={props.closeCallback}*/}
        {/*  class="bg-general-icondi border-up-stroke group z-[1] flex h-[28px] w-[28px] cursor-pointer items-center justify-center rounded-md"*/}
        {/*>*/}
        {/*  <Icon name="close" class={`h-[10px] w-[10px] cursor-pointer`} />*/}
        {/*</div>*/}
        <Icon
          name="general/xx1"
          onClick={props.closeCallback}
          class={`z-[1] h-[28px] w-[28px] cursor-pointer items-center justify-center rounded-md`}
        />
      </Show>
      <Show
        when={props?.closeCallback && icon() === "xx2" && props.showClose}
        fallback={<></>}
      >
        <Icon
          name="general/xx2_activity"
          onClick={props.closeCallback}
          class={cn(
            "z-[1] cursor-pointer items-center justify-center rounded-md",
            isMobile() ? "h-[28px] w-[28px]" : "h-[30px] w-[30px]",
          )}
        />
      </Show>
      <Show
        when={props?.closeCallback && !icon() && props.showClose}
        fallback={<></>}
      >
        <div
          onClick={props.closeCallback}
          class="group flex h-[28px] w-[28px] cursor-pointer items-center justify-center"
        >
          <Icon
            name="close"
            color="var(--general-white)"
            class={`size-[15px] cursor-pointer`}
          />
        </div>
      </Show>
      <Show when={!props.showClose && props.tip} fallback={<></>}>
        <div class={`flex flex-col items-end gap-[4px]`}>
          <div
            class={`text-general-light font-semibold ${isMobile() ? "text-[10px]" : "text-[12px]"}`}
          >
            {t("auth.no_time")}
          </div>
          <div
            class={`text-general-main font-bold ${isMobile() ? "text-[12px]" : "text-[14px]"}`}
            onClick={props.tipCallback}
          >
            {props.tip}
          </div>
        </div>
      </Show>
    </div>
  );
}
